import { fireEvent } from 'ggApp/modules/inwebview_api';
import { POST_EVENTS } from 'ggApp/modules/inwebview_api/constants';
import { isAppUser } from 'ggApp/routes/_wrap/MobileWrapper/utils';

// use this only on client side
const handleError = (error) => {
    if (error && error.type === 'unsupported') {
        console.warn('Click board is unsupported!');
        return;
    }
    console.warn('Copy event was failed!');
    console.warn(error);
};

const fallbackCopyTextToClipboard = (text) => {
    if (!document) {
        handleError({ type: 'unsupported' });
    }
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.position = 'fixed'; // avoid scrolling to bottom
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
        document.execCommand('copy');
    } catch (error) {
        handleError(error);
    } finally {
        document.body.removeChild(textArea);
    }
};

// https://stackoverflow.com/a/30810322
const copyTextToClipboard = ({ text }) => {
    if (isAppUser()) {
        fireEvent(POST_EVENTS.CLIPBOARD_WRITE, { text });
        return;
    }

    if (!navigator.clipboard) {
        fallbackCopyTextToClipboard(text);
        return;
    }
    navigator.clipboard.writeText(text).catch(handleError);
};

export default copyTextToClipboard;
